import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SignIn } from "@phosphor-icons/react";
import useSEO from "@/hooks/useSEO";
import { Logo } from "@/components/Logo";
import { adminApi, setToken } from "@/lib/adminApi";
import { apiError } from "@/lib/format";
import { BRAND_UPPER } from "@/lib/site";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useSEO({ title: `Admin Login – ${BRAND_UPPER}`, description: "Restricted administrator area.", path: "/admin/login", robots: "noindex, nofollow" });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await adminApi.post("/auth/login", { email, password });
      setToken(data.token);
      nav("/admin", { replace: true });
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center safe-x py-12 relative" data-testid="admin-login-page">
      <div className="absolute inset-0 dot-grid opacity-30 pointer-events-none" aria-hidden="true" />
      <form onSubmit={submit} className="relative glass glow-cyan-sm rounded-3xl p-7 sm:p-10 w-full max-w-md space-y-5" data-testid="admin-login-form">
        <Logo />
        <h1 className="font-display text-3xl font-black tracking-tight">Admin sign in</h1>
        <div>
          <label htmlFor="a-email" className="block text-xs tracking-[0.2em] uppercase text-slate-500 mb-2">Email</label>
          <input id="a-email" type="email" required autoComplete="username" className="field" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" />
        </div>
        <div>
          <label htmlFor="a-pass" className="block text-xs tracking-[0.2em] uppercase text-slate-500 mb-2">Password</label>
          <input id="a-pass" type="password" required autoComplete="current-password" className="field" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" />
        </div>
        {error && <p role="alert" className="text-sm text-red-300" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="admin-login-submit">
          <SignIn size={18} weight="bold" aria-hidden="true" /> {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
